/******************************************************************************************
 *	Consolidated Product Entity
 ******************************************************************************************/
(function() {
  

  /*
  * The ConsolidatedProduct is meant to be a rollup up multiple RcProduct instances that are:
  *  1. all consumable
  *  2. match their consumable fulfillable item codes and units
  *  3. thus should be displayed as a single entity in the UI, though listed as a separate license
  * */
  angular.module('rcEntities.consolidatedProduct', []).factory(
    'ConsolidatedProduct',
    /* @ngInject */
    function($log, _, ConsumableUsage, RcProduct) {
      function ConsolidatedProduct(productData) {
        const product = getRcProduct(productData);
        this.consumableName = _.invoke(product, 'getConsumableName');
        this.code = _.invoke(product, 'getConsumableFICode');
        this.units = _.invoke(product, 'getConsumableUnits');
        this.orgId = _.get(product, 'orgId');
        this.rcProducts = [];
        this.showMore = false;
        this.consumableUsageDataAvailable = false;
        if (product) {
          this.addProduct(product);
        }
      }

      ConsolidatedProduct.prototype.addProduct = function(productData) {
        const product = getRcProduct(productData);
        this.rcProducts.push(product);
      };

      ConsolidatedProduct.prototype.hasProduct = function(productData) {
        const product = getRcProduct(productData);
        return _.find(this.rcProducts, product);
      };

      ConsolidatedProduct.prototype.doesProductMatch = function(productData) {
        const product = getRcProduct(productData);
        // The product matches if the FI code, units and name all match this consolidated product
        return (
          product &&
          product.getConsumableFICode() === this.code &&
          product.getConsumableUnits() === this.units &&
          product.getConsumableName() === this.consumableName
        );
      };

      ConsolidatedProduct.prototype.getConsumableUnits = function() {
        return this.units;
      };

      ConsolidatedProduct.prototype.getConsumableCap = function() {
        if (this.rcProducts.length === 1) {
          return this.rcProducts[0].getConsumableCap();
        }
        return _.sumBy(this.rcProducts, product => _.parseInt(product.getConsumableCap()));
      };

      ConsolidatedProduct.prototype.getConsumableTotalQuantity = function() {
        if (this.totalQuantity) {
          return this.totalQuantity;
        }
        return _.sumBy(this.rcProducts, product => product.getConsumableTotalQuantity());
      };

      ConsolidatedProduct.prototype.getConsumableName = function() {
        return this.consumableName;
      };

      ConsolidatedProduct.prototype.getConsolidatedName = function() {
        return this.getConsumableName();
      };

      ConsolidatedProduct.prototype.isConsumptionBasedLicense = _.constant(true);

      ConsolidatedProduct.prototype.isConsolidated = _.constant(true);

      ConsolidatedProduct.prototype.setConsumableData = function(consumables) {
        this.consumables = consumables;
        if (consumables.length > 1) {
          $log.warn(
            'ConsolidatedProduct.setConsumableData(): we have more than one matching consumable. Only the first will be used.'
          );
        }
        if (!_.isEmpty(consumables)) {
          this.consumableUsageDataAvailable = true;
          const consumable = consumables[0];
          this.totalQuantity = consumable.totalQuantity;
          this.consumedQuantity = consumable.consumedQuantity;
          this.remainingQuantity = consumable.remainingQuantity;
          this.setConsumableUsageList(consumable.consumableUsageList);
          if (_.get(this, 'consumableUsageList.items.length') > 0) {
            this.usageTotal = consumable.usageTotal;
            this.showMore =
              this.usageTotal && this.consumableUsageList.items.length < this.usageTotal;
          } else {
            // We didn't get any usages, so manufacture a single one with the data from the Consumable rollup
            const consumableUsage = new ConsumableUsage({
              consumedQuantity: this.consumedQuantity,
              remainingQuantity: this.remainingQuantity,
              totalQuantity: this.totalQuantity
            });
            consumableUsage.name = _.get(this.rcProducts, '[0].name', this.getConsumableName());
            if (_.isArray(this.consumableUsageList.items)) {
              this.consumableUsageList.items.push(consumableUsage);
            }
          }
        }
      };

      ConsolidatedProduct.prototype.setConsumableUsageList = function(usageList) {
        this.consumableUsageList = usageList;
        if (_.get(this, 'consumableUsageList.items.length') > 0) {
          _.forEach(this.consumableUsageList.items, usage => {
            usage.name = this.getNameForUsage(usage);
          });
        }
      };

      ConsolidatedProduct.prototype.getNameForUsage = function(usage) {
        // find out the name for the usage, using the offer id if available and our list of products
        let matchingProduct;
        if (usage.offerId) {
          matchingProduct = findProductForOfferId(this, usage.offerId);
        } else if (!_.isEmpty(this.rcProducts) && this.rcProducts.length === 1) {
          // The usage didn't have an offer id, and we've determined there's only one product it could apply to anyway
          matchingProduct = this.rcProducts[0];
        }
        if (!matchingProduct) {
          return _.get(usage, 'unit', this.getConsumableName());
        }
        return _.get(matchingProduct, 'name', this.getConsumableName());
      };

      return ConsolidatedProduct;

      function getRcProduct(productData) {
        if (productData instanceof RcProduct) {
          return productData;
        } else if (_.has(productData, 'product') && productData.product instanceof RcProduct) {
          return productData.product;
        }
        return null;
      }

      function findProductForOfferId(model, offerId) {
        return _.find(model.rcProducts, {offerId: offerId});
      }
    }
  );
})();
